import { useSnackbar, OptionsObject } from 'notistack';

/**
 * Custom hook to handle notifications.
 */
const useNotification = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    /**
     * Show a notification.
     * @param message - The message to display.
     * @param variant - The variant of the snackbar.
     * @param options - Additional options for the snackbar.
     */
    const notify = (
        message: string,
        variant: 'default' | 'error' | 'success' | 'warning' | 'info' = 'default',
        options: OptionsObject = {}
    ) => {
        enqueueSnackbar(message, { variant, ...options });
    };

    /**
     * Dismiss a notification.
     * @param key - The key of the snackbar to dismiss.
     */
    const dismiss = (key: string) => {
        closeSnackbar(key);
    };

    return { notify, dismiss };
};

export default useNotification; 